export enum SedsButtonTypeOptions {
  FLAT = 'flat',
  OUTLINED = 'outlined',
  BASIC = 'basic',
  FAB = 'fab',
}
